"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("react-phone-input-2/lib/style.css");
var SelectWrapper_1 = __importDefault(require("./SelectWrapper"));
var Select = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var label = _a.label, values = _a.values, errors = _a.errors, defaultValue = _a.defaultValue, rest = __rest(_a, ["label", "values", "errors", "defaultValue"]);
    if (values) {
        return ((0, jsx_runtime_1.jsx)(SelectWrapper_1.default, { variant: rest.variant, ref: ref, name: rest.name, defaultValue: defaultValue || "", label: label, errors: errors, fieldRequired: rest.fieldRequired, children: (_b = Object.keys(values)) === null || _b === void 0 ? void 0 : _b.map(function (key) {
                return ((0, jsx_runtime_1.jsx)("option", { value: key, children: values === null || values === void 0 ? void 0 : values[key] }, key));
            }) }));
    }
    return ((0, jsx_runtime_1.jsx)(SelectWrapper_1.default, { fieldRequired: rest.fieldRequired, variant: rest.variant, ref: ref, name: rest.name, defaultValue: defaultValue || "", label: label, errors: errors }));
});
exports.default = Select;
